import "./InterviewAssessment.css";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";
import CandidateList from "../candidatelist/CandidateList";
import { motion } from "framer-motion";
import { Card, Row, Col, Typography, Button, Space, Divider } from "antd";

const { Title, Text } = Typography;

export default function InterviewAssessment() {
    const { authData, backUrl } = useContext(AuthContext);

    const [mrf, setMrf] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const [designationNames, setDesignationNames] = useState([]);
    const [showCandidates, setShowCandidates] = useState(false);
    const [currentMrfId, setCurrentMrfId] = useState();
    const [filterStatus, setFilterStatus] = useState("Open"); // 👈 new state

    const BASE_URL = backUrl;

    const fetchMrf = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/manpowerrequisitions/?mrf_status=${filterStatus}`, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            setMrf(res.data.results);
        } catch (err) {
            console.log("Failed to fetch MRFs:", err);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/organisations/`);
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.log("Failed to fetch organizations:", err);
        }
    };

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/`);
            setDepartmentNames(res.data.results);
        } catch (err) {
            console.log("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/designations/`);
            setDesignationNames(res.data.results);
        } catch (err) {
            console.log("Failed to fetch designations:", err);
        }
    };

    const getDepartmentName = (id) =>
        departmentNames.find((d) => d.id === id)?.name || "N/A";
    const getDesignationTitle = (id) =>
        designationNames.find((d) => d.id === id)?.name || "N/A";
    const getOrganizationName = (id) =>
        organizationNames.find((o) => o.id === id)?.name || "N/A";

    useEffect(() => {
        fetchMrf();
        fetchOrganizations();
        fetchDepartments();
        fetchDesignations();
    }, [filterStatus]);

    // 👇 filter MRFs based on selected button
    const filteredMrf = mrf.filter((item) => {
        if (filterStatus === "All") return true;
        if (filterStatus === "Open") return item.mrf_status === "Open";
        if (filterStatus === "Closed") return item.mrf_status === "Close";
        if (filterStatus === "Hold") return item.mrf_status === "On-hold";
        return true;
    });

    return (
        <>
            {!showCandidates ? (
                <motion.div
                    className="container interview-assessment-container my-4"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <div style={{ marginBottom: 16 }}>
                        <center>
                            <Title level={3} style={{ margin: 0, color: "#0e497b" }}>
                                Open Positions
                            </Title>

                            {/* 👇 Filter Buttons */}
                            <Space style={{ marginTop: 16 }}>
                                {/* <Button
                  type={filterStatus === "All" ? "primary" : "default"}
                  onClick={() => setFilterStatus(null)}
                >
                  All
                </Button> */}
                                <Button
                                    style={{
                                        backgroundColor: filterStatus === "Open" ? "#0e497b" : "#fff",
                                        color: filterStatus === "Open" ? "#fff" : "#0e497b",
                                        border: "1px solid #0e497b",
                                        fontWeight: "bold",
                                    }}
                                    onClick={() => setFilterStatus("Open")}
                                >
                                    Open
                                </Button>

                                <Button
                                    style={{
                                        backgroundColor: filterStatus === "Close" ? "#0e497b" : "#fff",
                                        color: filterStatus === "Close" ? "#fff" : "#0e497b",
                                        border: "1px solid #0e497b",
                                        fontWeight: "bold",
                                    }}
                                    onClick={() => setFilterStatus("Close")}
                                >
                                    Closed
                                </Button>

                                <Button
                                    style={{
                                        backgroundColor: filterStatus === "On-Hold" ? "#0e497b" : "#fff",
                                        color: filterStatus === "On-Hold" ? "#fff" : "#0e497b",
                                        border: "1px solid #0e497b",
                                        fontWeight: "bold",
                                    }}
                                    onClick={() => setFilterStatus("On-Hold")}
                                >
                                    Hold
                                </Button>

                            </Space>
                        </center>
                    </div>

                    {filteredMrf.length > 0 ? (
                        <Row gutter={[24, 24]}>
                            {filteredMrf.map((mrfItem, index) => (
                                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                    <motion.div
                                        whileHover={{
                                            scale: 1.03,
                                            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                                        }}
                                        whileTap={{ scale: 0.97 }}
                                        transition={{ type: "spring", stiffness: 300 }}
                                    >
                                        <Card
                                            hoverable
                                            bordered
                                            style={{
                                                borderRadius: 12,
                                                minHeight: 200,
                                                background: "#f9fbff",
                                            }}
                                            actions={[
                                                <Button
                                                    block
                                                    onClick={() => {
                                                        setCurrentMrfId(mrfItem.mrf_number);
                                                        setShowCandidates(true);
                                                    }}
                                                    style={{
                                                        width: "fit-content",
                                                        backgroundColor: "#0c3e6a",
                                                        color: "white",
                                                    }}
                                                >
                                                    View Candidates
                                                </Button>,
                                            ]}
                                        >
                                            <Space direction="vertical" size={6} style={{ width: "100%" }}>
                                                <Text strong style={{ fontSize: 16 }}>
                                                    {getDesignationTitle(mrfItem.designation)}
                                                </Text>
                                                <Text type="secondary">{getDepartmentName(mrfItem.department)}</Text>
                                                <Divider style={{ margin: "8px 0" }} />
                                                <Text>
                                                    <strong>MRF Number:</strong> {mrfItem.mrf_number}
                                                </Text>
                                                <Text>
                                                    <strong>Organization:</strong> {getOrganizationName(mrfItem.organisation)}
                                                </Text>
                                                <Text>
                                                    <strong>Vacancies:</strong> {mrfItem.no_of_vacancies}
                                                </Text>
                                                <Text>
                                                    <strong>Status:</strong> {mrfItem.mrf_status === "Close" ? "Closed" : mrfItem.mrf_status}
                                                </Text>
                                            </Space>
                                        </Card>
                                    </motion.div>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <Text type="secondary" className="d-block text-center mt-4">
                            No positions found.
                        </Text>
                    )}
                </motion.div>
            ) : (
                <div id="interview-assessment-area">
                    <CandidateList
                        mrf={currentMrfId}
                        onBack={() => setShowCandidates(false)}
                        showCandidates={showCandidates}
                    />
                </div>
            )}
        </>
    );
}
